import {Component, Input, OnDestroy, OnInit, inject} from '@angular/core';
import {I18nService} from '../../../_services/gui/i18n.service';
import {AuthenticationService} from '../../../_services/authentication.service';
import {UntypedFormBuilder} from '@angular/forms';
import {User} from '../../../_data/admin/user';
import {UsersService} from '../../../_services/data/users.service';
import {first, mergeMap} from 'rxjs/operators';
import {MfaService} from '../../../_services/data/mfa.service';
import {MfaUserDetails} from '../../../_data/mfa/mfa-user-details';
import {ResetPasswordComponent} from '../reset-password/reset-password.component';
import {UserDeviceAdminComponent} from '../../../mfa/user-device-admin/user-device-admin.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    imports: [ResetPasswordComponent, UserDeviceAdminComponent, TranslateModule]
})
export class EditProfileComponent implements OnInit, OnDestroy {

  @Input() hideHeadings = false;
  @Input() saveEnabled: boolean = true;

  // userProfileFormGroup: FormGroup;
  formSubmitted: boolean = false;
  user: User;
  mfaUserDetails: MfaUserDetails;
  addMfa: boolean;
  // changePassword: boolean = false;
  numMfaDevices: number = 0;

  authenticationService = inject(AuthenticationService);
  mfaService = inject(MfaService);
  
  private formBuilder = inject(UntypedFormBuilder);
  private i18nService = inject(I18nService);
  private usersService = inject(UsersService);

  // private setFormFromUser(u: User) {
  //   const controls = this.userProfileFormGroup.controls;
  //   controls.firstName.setValue(u.firstName);
  //   controls.middleName.setValue(u.middleName);
  //   controls.lastName.setValue(u.lastName);
  //   controls.email.setValue(u.email);
  //   controls.phone.setValue(u.phone);
  //   controls.extension.setValue(u.extension);
  // }

  ngOnInit() {
    this.i18nService.setTitle('title.admin.users.edit-profile');

    // this.userProfileFormGroup = this.formBuilder.group({
    //   firstName:  ['', Validators.required],
    //   middleName: '',
    //   lastName:   ['', Validators.required],
    //   email:      ['', Validators.email],
    //   phone:      '',
    //   extension:  ''
    // });

    this.authenticationService.userName$.pipe(
      first(),
      mergeMap(userName => this.usersService.getUserDetails(userName))
    ).subscribe(response => {
      this.user = response.body;
      // this.setFormFromUser(this.user);
    });

  }

  ngOnDestroy(): void {
  }

  onPasswordChanged(success: boolean) {
    if(success) {
      this.authenticationService.logout();
    }
  }

  // public get f(): FormGroup {
  //   return this.userProfileFormGroup;
  // }
  //
  // public get c(): {[p: string]: AbstractControl} {
  //   return this.userProfileFormGroup.controls;
  // }
}
